import { format, isAfter, isValid } from 'date-fns';
import { useMemo } from 'react';
import { DATE_PATTERN, MAX_DATE, MIN_DATE } from '../utilities/constants.js';
export function useMinMaxDate({ min = MIN_DATE, max = MAX_DATE, pattern = DATE_PATTERN } = {}) {
    return useMemo(() => {
        if (!min && !max) {
            return { min: MIN_DATE, max: MAX_DATE };
        }
        let validMin = !min
            ? MIN_DATE
            : isValid(min)
                ? min
                : (console.error(`Invalid min date provided, defaulting to ${format(MIN_DATE, pattern)}`), MIN_DATE);
        let validMax = !max
            ? MAX_DATE
            : isValid(max)
                ? max
                : (console.error(`Invalid max date provided, defaulting to ${format(MAX_DATE, pattern)}`), MAX_DATE);
        if (isAfter(validMin, validMax)) {
            console.error(`Invalid min and max date provided, defaulting to ${format(MIN_DATE, pattern)} and ${format(MAX_DATE, pattern)}`);
            validMin = MIN_DATE;
            validMax = MAX_DATE;
        }
        return { min: validMin, max: validMax };
    }, [min, max, pattern]);
}
//# sourceMappingURL=useMinMaxDate.js.map